// src/list.ts
function normalizeIndex(length, index) {
	return index < 0 ? length + index : index;
}
function updateItemToList(list, index, newValue) {
	const normalizedIndex = normalizeIndex(list.length, index);
	if (normalizedIndex < 0) return [...list];
	return [
		...list.slice(0, normalizedIndex),
		newValue,
		...list.slice(normalizedIndex + 1)
	];
}
function removeItemAtIndex(list, index) {
	const normalizedIndex = normalizeIndex(list.length, index);
	if (normalizedIndex < 0) return [...list];
	return [...list.slice(0, normalizedIndex), ...list.slice(normalizedIndex + 1)];
}
function moveAtFirstIndex(list, index) {
	const normalizedIndex = normalizeIndex(list.length, index);
	if (normalizedIndex < 0 || normalizedIndex >= list.length) return [...list];
	const [item] = list.slice(normalizedIndex, normalizedIndex + 1);
	return [
		item,
		...list.slice(0, normalizedIndex),
		...list.slice(normalizedIndex + 1)
	];
}
function hasAtLeastOneItem(list) {
	return list.length > 0;
}
function isEmpty(list) {
	return list.length === 0;
}
const MISSING_ITEM_INDEX = -1;
// src/generator.ts
function* numberGenerator(start, excludes = []) {
	for (let i = start; i < 1e6; i++) {
		if (excludes.includes(i)) continue;
		yield i;
	}
}
export { MISSING_ITEM_INDEX, hasAtLeastOneItem, isEmpty, moveAtFirstIndex, numberGenerator, removeItemAtIndex, updateItemToList };

//# sourceMappingURL=index.mjs.map